import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// FAQ Data
const helpData = {
  MerchantPay: [
    {
      question: "What is Merchant Pay?",
      answer: `Merchant Pay is used to make payment to merchants who are previously registered under TA Wallet. Any merchant establishment serving TA Wallet holders will prominently display "TA Wallet Accepted Here" with a QR Code.`,
    },
    {
      question: "What is Merchant ID?",
      answer: `Merchant ID is a unique four-digit merchant identifier used for identifying merchants/establishments registered within TA Wallet.`,
    },
    {
      question: "How do anyone make payment using MerchantPay?",
      answer: `User can make payment to the merchant by following methods:

1) In wallet, go to - Merchant Pay → Scan code.

2) Tap on the QR code icon (top right corner) and scan the merchant's QR code placed at the establishment. The merchant's name will appear on screen — enter the exact amount and click Pay. It is safe and simple to use.

3) You can also make payment by using the four-digit merchant ID (enter manually in the app) or the merchant's mobile number. Ask the merchant for the mobile number. (Ensure the merchant's name displayed is correct)`,
    },
  ],
};

const MerchantPay = ({ selectedSection = "MerchantPay" }) => {
  const questions = helpData[selectedSection] || [];
  const [openIndex, setOpenIndex] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const toggleAnswer = (index) =>
    setOpenIndex((prev) => (prev === index ? null : index));

  return (
    <Box width="100%">
      {/* Top Banner */}
      <Box
        sx={{
          width: "100%",
          height: { xs: 180, sm: 220, md: 260 },
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 1, sm: 3 },
        }}
      >
        <Box
          component="img"
          src="/Assets/marchantpayment.jpg"
          alt="Merchant payment banner"
          sx={{
            width: "100%",
            maxWidth: 1000,
            height: "100%",
            objectFit: "cover",
            borderRadius: "0 0 10px 10px",
          }}
        />
      </Box>

      {/* Heading */}
      <Box mt={3} display="flex" justifyContent="center">
        <Typography
          variant={isMobile ? "h6" : "h5"}
          fontWeight="bold"
          color="black"
        >
          Merchant Pay
        </Typography>
      </Box>

      {/* FAQ Section */}
      <Box
        sx={{
          width: "100%",
          maxWidth: 900,
          mx: "auto",
          px: { xs: 1.5, sm: 2, md: 3 },
          mt: 2,
          py: 2,
        }}
      >
        <List disablePadding>
          {questions.map((item, index) => (
            <Box
              key={index}
              sx={{
                border: "1px solid #ddd",
                borderRadius: 2,
                mb: 2,
                overflow: "hidden",
                boxShadow:
                  openIndex === index ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
                transition: "box-shadow 0.2s ease-in-out",
              }}
            >
              <ListItemButton
                onClick={() => toggleAnswer(index)}
                sx={{
                  borderBottom: "1px solid #eee",
                  px: 2,
                  py: 1.5,
                  backgroundColor:
                    openIndex === index ? "#e0f7fa" : "transparent",
                  "&:hover": {
                    backgroundColor:
                      openIndex === index ? "#b2ebf2" : "#f9f9f9",
                  },
                }}
              >
                <ListItemText primary={item.question} />
                {openIndex === index ? (
                  <ExpandMoreIcon sx={{ fontSize: 18 }} />
                ) : (
                  <ArrowForwardIosIcon sx={{ fontSize: 14 }} />
                )}
              </ListItemButton>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Box px={3} py={2} bgcolor="#fafafa">
                  <Typography
                    variant="body2"
                    sx={{ whiteSpace: "pre-wrap", lineHeight: 1.6 }}
                  >
                    {item.answer}
                  </Typography>
                </Box>
              </Collapse>
            </Box>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default MerchantPay;
